import RootPage from './global-insuredactions.page.vue'

let routes = [
  {
    path: '/global-insured-actions',
    name: 'global-insured-actions',
    component: RootPage
  },
]

export default routes
